import f56_1 from "../../assets/samsung/f56/F56.jpeg";
import f56_2 from "../../assets/samsung/f56/F56_2.jpeg";
import f56_3 from "../../assets/samsung/f56/F56_3.jpeg";
import f56_4 from "../../assets/samsung/f56/F56_4.jpeg";

import f16_1 from "../../assets/samsung/f16/F16_1.jpeg";
import f16_2 from "../../assets/samsung/f16/F16_2.jpeg";
import f16_3 from "../../assets/samsung/f16/F16_3.jpeg";
import f16_4 from "../../assets/samsung/f16/F16_4.jpeg";
import f16_5 from "../../assets/samsung/f16/F16_5.jpeg";
import f16_6 from "../../assets/samsung/f16/F16_6.jpeg";


export const galaxyFSeries = [
  {
    id: 1,
    title: "Galaxy F56 5G",
    productImage: f56_1,
    images: [f56_1, f56_2, f56_3, f56_4],
    // originalPrice: '₹ 13,999',
    discountedPrice: "30,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Green", "Violet"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.7"inch Super AMOLED+, Full HD+ (1080 x 2340)',
        "Max. Refresh Rate = 120 Hz",
        "Powered by Exynos 1480(4nm, vapor chamber cooling)",
        "Up to 8GB RAM & Up to 256GB Storage",
        "Triple Rear camera - 50 MP(Main sensor with OIS & 2x zoom)+ 8 MP(Ultra-wide) + 2 MP(Macro)",
        "Front Camera - 12MP (HDR) selfie cam",
        "5000mah battery, Supports 45 W fast charging",
      ],
    },
  },
   {
    id: 2,
    title: "Galaxy F16",
    productImage: f16_1,
    images: [f16_1, f16_2, f16_3, f16_4,f16_5,f16_6],
    // originalPrice: '₹ 13,999',
    discountedPrice: "15,999",
    // offerText: 'Flat ₹3,901 off',
    colors: ["Vibing Blue" , "Bling Black", "Glam Green"],
    offers: [
      // { label: 'Offer', value: 'Get ₹1500 off on Axis Bank Credit Card' },
      // { label: 'EMI', value: 'Available from ₹999/month' },
    ],
    specifications: {
      // Audio: 'Dolby Atmos',
      // Battery: '5000mAh with 25W fast charging',
      // Controls: 'On-screen fingerprint scanner',
      // Compatibility: 'Works with Android 13',
      // Specs: {
      //   Chip: 'Exynos 1380',
      //   Connectivity: '5G, Wi-Fi 5',
      //   Case: 'Supports wireless charging',
      //   Weight: '202g',
      //   WaterResistance: 'IP67',
      //   Warranty: '1 year',
      // },
      Specs: [
        '6.7"inch Super AMOLED+, Full HD+ (1080 x 2340)',
        "Max. Refresh Rate = 90 Hz",
        "Powered by MediaTek Dimensity 6300 (6nm; octa-core)",
        "Up to 8GB RAM & Up to 128GB Storage; expendable external Storage support - MicroSD up to 1.5TB",
        "Triple Rear cameras - 50 MP main sensor (f/1.8) with up to 10x digital zoom + 5 MP ultra-wide + 2 MP macro shooter",
        "Front Camera - 13MP selfie sensor",
        "5000mah battery, Supports 25 W fast charging",
      ],
    },
  },
];
